module.exports = __webpack_public_path__ + "8544f056e03953b434f6bba8a1b328ff.png";